export default {
    th: {

    },
    en: {
    }
}